// import React, { Component } from "react";
// //import NavbarFrontend from "components/Frontend/Navbar/NavbarFrontend";
// import HerosFrontend from "components/Frontend/Heros/HerosFrontend";
// import BrandFrontend from "components/Frontend/Brand/BrandFrontend";
// import ContentHome from "components/Frontend/Content/ContentHome";
// import FooterFrontend from "components/Frontend/Footer/FooterFrontend";

// import NavbarFrontend from "components/react-bootstrap/NavbarFrontend";

// export default class Home extends Component {
//   render() {
//     return (
//       <div>
//         {/* <NavbarFrontend />
//         <HerosFrontend />
//         <BrandFrontend />
//         <ContentHome />
//         <FooterFrontend /> */}
//         <h1>home</h1>
//       </div>
//     );
//   }
// }

import BrandFrontend from "components/Frontend/Brand/BrandFrontend";
import CardContentHome from "components/Frontend/Card/CardContentHome";
import CardContentProject from "components/Frontend/Card/CardContentProject";
import CardCategoryArticle from "components/Frontend/Card/CardCategoryArticle";
import ContentHome from "components/Frontend/Content/ContentHome";
import FooterFrontend from "components/Frontend/Footer/FooterFrontend";
import HerosFrontend from "components/Frontend/Heros/HerosFrontend";
import React from "react";
import { Link } from "react-router-dom";
import CallToAction from "components/Frontend/Content/CallToAction";
import CardTeam from "components/Frontend/Card/CardTeam";

function Home() {
  return (
    <div>
      <HerosFrontend />
      <BrandFrontend />
      {/* Services Section */}
      <section id="services" className="services">
        <div className="container">
          <div className="section-title">
            <h2>Kategori</h2>
            <p>Temui Kelas Berdasarkan Kategori Yang Kami Sediakan</p>
          </div>

          <div className="row">
            <CardCategoryArticle />
          </div>
        </div>
      </section>
      {/* End Services Section */}

      {/* <div className="container">
        <div className="row content-text mt-5 text-center">
          <div className="col-12 px-md-0 my-auto">
            <h5 className="tagline">List Project</h5>
            <h1 className="headline mt-3">
              Beberapa project <br className="d-none d-md-block" />
              yang kami kerjakan
            </h1>
          </div>
        </div>
        <CardContentProject />
        <div className="row">
          <div className="text-center mt-4">
            <a href="#" className="btn btn-primary me-2">
              Project Lainnnya
            </a>
            <Link href="#" className="btn btn-outline-warning">
              Hubungi kami
            </Link>
          </div>
        </div>
      </div> */}

      <div className="container">
        <div className="row content-text mt-5 text-center">
          <div className="col-12 px-md-0 my-auto">
            <h5 className="tagline">Pilihan materi</h5>
            <h1 className="headline mt-3">
              Beberapa pilihan <br className="d-none d-md-block" />
              materi rekomendasi kami
            </h1>
          </div>
        </div>
        <CardContentHome />
        <div className="row">
          <div className="text-center mt-4">
            <button className="btn btn-primary me-2">
              See All Categories
            </button>
            <button className="btn btn-outline-warning">
              Need help?
            </button>
          </div>
        </div>
        <CardContentProject />
      </div>
      <CallToAction />
      <CardTeam />
    </div>
  );
}

export default Home;
